import React from 'react';
import CTAButton from './CTAButton';
const StickyCTA = () => {
  return <div className="fixed bottom-0 left-0 right-0 bg-white shadow-lg border-t border-gray-200 p-2 sm:p-3 z-50" data-id="element-273">
      <div className="w-full max-w-full mx-auto px-2 sm:px-4 md:px-6 lg:px-8" data-id="element-274">
        <CTAButton text="CLAIM YOUR 50% DISCOUNT NOW" href="https://trynymera.com/products/nymera-sleep-strips" data-id="element-275" />
      </div>
    </div>;
};
export default StickyCTA;